<template>
  <div class="pedidos-container" :class="{ 'no-header': hideHeaderControls }">
    <modal_pdf_pedido ref="modal_pdf_pedido"/>
    <modal-boleto ref="modal_boletos"/>
    <modal-nf ref="modalNf"/>

    <b-overlay :show="isLoading" variant="light" opacity="0.85" blur="2px">
      <div class="table-header" v-if="!hideHeaderControls">
        <div class="table-info">
          <feather-icon icon="PackageIcon" size="16" class="info-icon" />
          <span class="record-count">{{ totalRecords }} pedido{{ totalRecords !== 1 ? 's' : '' }}</span>
        </div>
        <div class="table-controls">
          <label class="per-page-label">Exibir:</label>
          <select
            class="per-page-select"
            :value="getMeta.pageSize"
            @change="pageSelect($event)"
          >
            <option :value="10">10</option>
            <option :value="20">20</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
          </select>
        </div>
      </div>

      <div class="table-wrapper">
        <table class="data-table" v-if="getPedidoVendas.length > 0">
          <thead>
            <tr>
              <th>PRÉ PEDIDO</th>
              <th>PEDIDO ERP</th>
              <th>CLIENTE</th>
              <th>REPRESENTANTE</th>
              <th class="text-center">EMISSÃO</th>
              <th class="text-center">PREV. ENTREGA</th>
              <th class="text-right">VALOR TOTAL</th>
              <th class="text-center">SITUAÇÃO</th>
              <th class="text-center">SIT. ERP</th>
              <th class="text-center">AÇÕES</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in getPedidoVendas" :key="item.pedidoId">
              <td class="font-mono">{{ item.pedidoNumeroCliente }}</td>
              <td class="font-mono">{{ item.pedidoNumeroIntegracao || '-' }}</td>
              <td>
                <div class="client-info">
                  <span class="client-id">{{ item.clienteIdERP }}</span>
                  <span class="client-name">{{ item.clienteRazaoSocial }}</span>
                </div>
              </td>
              <td>
                <div class="rep-info" v-if="item.representanteId">
                  <span class="rep-id">{{ item.representanteId }}</span>
                  <span class="rep-name">{{ item.representantenome }}</span>
                </div>
                <span v-else class="text-muted">-</span>
              </td>
              <td class="text-center">{{ item.pedidoData }}</td>
              <td class="text-center">{{ item.pedidoDataEntregaPrevista || '-' }}</td>
              <td class="text-right font-mono">{{ formatValorComImpostos(item) }}</td>
              <td class="text-center">
                <!-- <StatusBadge :status="item.pedidoSitSales" /> -->
                 {{ item.pedidoSitSales }}
              </td>
              <td class="text-center">
                <!-- <StatusBadge :status="item.pedidoSitComercial" /> -->
                 {{ item.pedidoSitComercial }}
              </td>
              <td class="text-center">
                <div class="action-buttons">
                  <button
                    class="action-btn action-btn-view"
                    @click="detalhePedido(item)"
                    title="Ver Detalhes"
                  >
                    <feather-icon icon="EyeIcon" size="16" />
                  </button>
                  <button
                    class="action-btn action-btn-pdf"
                    @click="showModalPdf(item)"
                    title="Gerar PDF"
                  >
                    <feather-icon icon="FileTextIcon" size="16" />
                  </button>
                  <!-- <button
                    v-if="item.notaFiscalNumero"
                    class="action-btn action-btn-boleto"
                    @click="exibirModalBoleto(item)"
                    title="Ver Boleto"
                  >
                    <feather-icon icon="CreditCardIcon" size="16" />
                  </button> -->
                  <button
                    v-if="item.NotaFiscal && item.NotaFiscal.length"
                    class="action-btn action-btn-boleto"
                    @click="copiarNF(item.NotaFiscal)"
                    title="Copiar Nota Fiscal"
                  >
                    <feather-icon icon="FileIcon" size="16" />
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-else class="empty-state">
          <div class="empty-icon">
            <feather-icon icon="InboxIcon" size="48" />
          </div>
          <p class="empty-text">Nenhum pedido encontrado</p>
          <p class="empty-subtext">Ajuste os filtros para ver resultados</p>
        </div>
      </div>

      <div class="table-footer" v-if="getPedidoVendas.length > 0">
        <div class="pagination-info">
          Mostrando {{ startRecord }} a {{ endRecord }} de {{ totalRecords }} registros
        </div>
        <div class="pagination-controls">
          <button
            class="page-btn"
            :disabled="getMeta.page <= 1"
            @click="goToPage(1)"
            title="Primeira página"
          >
            <feather-icon icon="ChevronsLeftIcon" size="16" />
          </button>
          <button
            class="page-btn"
            :disabled="getMeta.page <= 1"
            @click="goToPage(getMeta.page - 1)"
            title="Página anterior"
          >
            <feather-icon icon="ChevronLeftIcon" size="16" />
          </button>

          <button
            v-for="page in visiblePages"
            :key="page"
            class="page-btn page-number"
            :class="{ active: page === getMeta.page }"
            @click="goToPage(page)"
          >
            {{ page }}
          </button>

          <button
            class="page-btn"
            :disabled="getMeta.page >= totalPages"
            @click="goToPage(getMeta.page + 1)"
            title="Próxima página"
          >
            <feather-icon icon="ChevronRightIcon" size="16" />
          </button>
          <button
            class="page-btn"
            :disabled="getMeta.page >= totalPages"
            @click="goToPage(totalPages)"
            title="Última página"
          >
            <feather-icon icon="ChevronsRightIcon" size="16" />
          </button>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal_pdf_pedido from '@/views/app/operacoes/pedidosVendas/modal/modal_pdf_pedido.vue';
import ModalBoleto from '@/views/app/operacoes/pedidosVendas/modal/modalBoleto.vue';
import { formtPriceBr } from '@core/utils/filter';
import modalNf from './modal/modalNF.vue';
import StatusBadge from './components/StatusBadge.vue';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';

export default {
  components: {
    ModalBoleto,
    Modal_pdf_pedido,
    modalNf,
    StatusBadge,
  },
  props: {
    hideHeaderControls: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    formtPriceBr,
  },
  computed: {
    ...mapGetters({
      getPedidoVendas: 'SLS_PedidosVendas/getPedidoVendas',
      getMeta: 'SLS_PedidosVendas/getMeta',
    }),
    isLoading() {
      return this.$store.getters['SLS_PedidosVendas/getIsLoading'];
    },
    totalRecords() {
      return this.getMeta?.total || 0;
    },
    totalPages() {
      return Math.ceil(this.totalRecords / (this.getMeta?.pageSize || 10));
    },
    startRecord() {
      if (this.totalRecords === 0) return 0;
      return ((this.getMeta?.page || 1) - 1) * (this.getMeta?.pageSize || 10) + 1;
    },
    endRecord() {
      const end = (this.getMeta?.page || 1) * (this.getMeta?.pageSize || 10);
      return Math.min(end, this.totalRecords);
    },
    visiblePages() {
      const pages = [];
      const current = this.getMeta?.page || 1;
      const total = this.totalPages;

      let start = Math.max(1, current - 2);
      let end = Math.min(total, current + 2);

      if (end - start < 4) {
        if (start === 1) {
          end = Math.min(total, start + 4);
        } else if (end === total) {
          start = Math.max(1, end - 4);
        }
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    },
  },
  methods: {
    formatValorComImpostos(item) {
      if (item.pedidototalcomimpostos !== null && item.pedidototalcomimpostos !== undefined && item.pedidototalcomimpostos !== '') {
        const valor = Number(item.pedidototalcomimpostos);
        return Number.isNaN(valor) ? item.pedidototalcomimpostos : this.formatCurrency(valor);
      }
      return item.pedidoValorTotal || 'R$ 0,00';
    },
    formatCurrency(value) {
      if (value === null || value === undefined) return 'R$ 0,00';
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(value);
    },
    async goToPage(pageNum) {
      const page = parseInt(pageNum);
      if (page < 1 || page > this.totalPages || page === this.getMeta.page) return;
      await this.$emit('paginateFilters', { page });
    },
    async pageSelect(event) {
      const pageSize = parseInt(event.target.value);
      await this.$emit('paginateFilters', { pageSize, page: 1 });
    },
    async copiarNF(notaFiscal) {
      try {
        console.log('Nota Fiscal a ser copiada:', notaFiscal);
        const texto = Array.isArray(notaFiscal)
          ? notaFiscal.map(nf =>
              `Série: ${nf.notafiscalserie}\nNúmero: ${nf.notafiscalnumero}\nEmissão: ${nf.notafiscaldtemissao}\nConfirmação: ${nf.notafiscaldtconfirma}\nPrevisão de entrega: ${nf.notafiscaldtpreventrega}\nAtualização ACR: ${nf.notafiscaldtatualizaacr}\nData de saída de entrega: ${nf.notafiscaldtsaidaentrega}\nValor total: ${nf.notafiscalvalortotal}`
            ).join('\n\n')
          : String(notaFiscal);

        await navigator.clipboard.writeText(texto);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sucesso',
            text: 'Nota Fiscal copiada para área de transferência!',
            icon: 'CheckCircleIcon',
            variant: 'success',
          },
        });
      } catch (err) {
        console.error(err);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Falha ao copiar Nota Fiscal. Tente novamente.',
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        });
      }
    },
    async exibirModalBoleto(boleto) {
      this.$refs.modal_boletos.showModalBoleto({
        clienteId: boleto.clienteId,
        pedidoId: boleto.pedidoId,
      });
    },
    async detalhePedido(data) {
      await this.$router.push({
        name: 'pedidos-vendas-detalhes',
        params: { pedidoid: data.pedidoId, clienteid: data.clienteId },
      });
    },
    showModalPdf(data) {
      this.$refs.modal_pdf_pedido.showModalPdf(data);
    },
  },
};
</script>

<style scoped>
.pedidos-container {
  padding: 0.75rem;
}

.pedidos-container.no-header {
  padding: 0;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0 0.75rem;
}

.table-info {
  display: flex;
  align-items: center;
  gap: 0.375rem;
}

.info-icon {
  color: var(--sf-accent);
}

.record-count {
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--sf-text-primary);
}

.table-controls {
  display: flex;
  align-items: center;
  gap: 0.375rem;
}

.per-page-label {
  font-size: 0.75rem;
  color: var(--sf-text-secondary);
  margin: 0;
}

.per-page-select {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  border: 1px solid var(--sf-form-border);
  border-radius: 4px;
  background: var(--sf-form-bg);
  color: var(--sf-form-text);
  cursor: pointer;
}

.table-wrapper {
  overflow-x: auto;
}

.no-header .table-wrapper {
  border-radius: 0;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8125rem;
}

.data-table thead {
  background: var(--sf-table-header-bg);
}

.data-table th {
  padding: 0.5rem 0.75rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.6875rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--sf-table-header-text);
  border-bottom: 1px solid var(--sf-table-border);
  white-space: nowrap;
}

.data-table td {
  padding: 0.5rem 0.75rem;
  color: var(--sf-table-text);
  border-bottom: 1px solid var(--sf-table-border);
  vertical-align: middle;
}

.data-table tbody tr:hover {
  background: var(--sf-table-row-hover);
}

.data-table tbody tr:last-child td {
  border-bottom: none;
}

.text-center {
  text-align: center !important;
}

.text-right {
  text-align: right !important;
}

.font-mono {
  font-family: ui-monospace, SFMono-Regular, 'SF Mono', Menlo, Monaco, Consolas, monospace;
  font-size: 0.75rem;
}

.text-muted {
  color: var(--sf-text-muted);
}

.client-info,
.rep-info {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.client-id,
.rep-id {
  font-weight: 600;
  font-size: 0.75rem;
  color: var(--sf-text-primary);
}

.client-name,
.rep-name {
  font-size: 0.6875rem;
  color: var(--sf-text-secondary);
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 0.125rem;
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.action-btn-view {
  background: rgba(59, 130, 246, 0.1);
  color: #3b82f6;
}

.action-btn-view:hover {
  background: rgba(59, 130, 246, 0.2);
}

.action-btn-pdf {
  background: rgba(16, 185, 129, 0.1);
  color: #10b981;
}

.action-btn-pdf:hover {
  background: rgba(16, 185, 129, 0.2);
}

.action-btn-boleto {
  background: rgba(245, 158, 11, 0.1);
  color: #f59e0b;
}

.action-btn-boleto:hover {
  background: rgba(245, 158, 11, 0.2);
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  text-align: center;
}

.empty-icon {
  color: var(--text-muted, #94a3b8);
  margin-bottom: 1rem;
}

.empty-text {
  font-size: 1rem;
  font-weight: 500;
  color: var(--text-primary, #1e293b);
  margin: 0 0 0.25rem;
}

.empty-subtext {
  font-size: 0.875rem;
  color: var(--text-secondary, #64748b);
  margin: 0;
}

.table-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.75rem;
  flex-wrap: wrap;
  gap: 0.5rem;
  border-top: 1px solid var(--sf-border-color);
  background: var(--sf-surface-bg);
}

.no-header .table-footer {
  border-radius: 0 0 8px 8px;
}

.pagination-info {
  font-size: 0.75rem;
  color: var(--sf-text-secondary);
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 0.125rem;
}

.page-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  padding: 0 0.375rem;
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--sf-text-secondary);
  background: transparent;
  border: 1px solid var(--sf-border-color);
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.page-btn:hover:not(:disabled) {
  background: var(--sf-dropdown-hover);
  color: var(--sf-accent);
  border-color: var(--sf-accent);
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-btn.active {
  background: var(--sf-accent);
  color: #ffffff;
  border-color: var(--sf-accent);
}

.page-number {
  font-weight: 500;
}

@media (max-width: 768px) {
  .pedidos-container {
    padding: 0.5rem;
  }

  .pedidos-container.no-header {
    padding: 0;
  }

  .table-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .table-footer {
    flex-direction: column;
    align-items: center;
  }

  .data-table th,
  .data-table td {
    padding: 0.375rem 0.5rem;
  }

  .client-name,
  .rep-name {
    max-width: 100px;
  }
}
</style>
